import PropertiesContainer from './PropertiesContainer';

export default PropertiesContainer;
